import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import EventsPage from "./pages/EventsPage";
import EventDetailsPage from "./pages/EventDetailsPage";
import OrganizersPage from "./pages/OrganizersPage";
import OrganizersApplyPage from "./pages/OrganizersApplyPage";
import AddEventPage from "./pages/AddEventPage";
import BlogPage from "./pages/BlogPage";
import AboutPage from "./pages/AboutPage";
import LoginPage from "./pages/LoginPage";
import ProfilePage from "./pages/ProfilePage";
import MagicLinkCallback from "./pages/MagicLinkCallback";
import AdminPage from "./pages/AdminPage";
import MessagesPage from "./pages/MessagesPage";
import OrganizerProfilePage from "./pages/OrganizerProfilePage";
import FavoritesPage from "./pages/FavoritesPage";
import MyEventsPage from "./pages/MyEventsPage";
import NotificationsPage from "./pages/NotificationsPage";
import MetricsPage from "./pages/MetricsPage";
import OrganizerEventAttendeesPage from "./pages/OrganizerEventAttendeesPage";
import OrganizerPaymentsPage from "./pages/OrganizerPaymentsPage";
import NotFoundPage from "./pages/NotFoundPage";
import PlaceholderPage from "./pages/PlaceholderPage";
import { termsContent, privacyContent } from "./data/legalContent";
import Navbar from "./components/Navbar";
import InstallBanner from "./components/InstallBanner";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider, withLang } from "./i18n/LanguageContext";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{padding: '60px 20px', textAlign: 'center', maxWidth: 480, margin: '0 auto'}}>
          <h2 style={{fontFamily: 'Cormorant Garamond, serif', fontSize: 28, marginBottom: 16, color: '#3d3d3d'}}>
            Что-то пошло не так
          </h2>
          <p style={{color: '#6b6b6b', marginBottom: 24}}>Попробуйте обновить страницу</p>
          <button
            onClick={() => { window.location.href = '/'; }}
            style={{background: '#BDA27A', color: '#fff', border: 'none', padding: '12px 32px', borderRadius: 50, cursor: 'pointer', fontSize: 15}}
          >
            На главную
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Detect if running under /api/_app/ path (CDN bypass mode)
const isApiApp = window.location.pathname.startsWith('/api/_app');
const basename = isApiApp ? '/api/_app' : '';

const routes = [
  ["/", <HomePage />],
  ["/events", <EventsPage />],
  ["/events/:id", <EventDetailsPage />],
  ["/organizers", <OrganizersPage />],
  ["/organizers/:id", <OrganizerProfilePage />],
  ["/organizers/apply", <OrganizersApplyPage />],
  ["/add-event", <AddEventPage />],
  ["/events/:id/edit", <AddEventPage />],
  ["/blog", <BlogPage />],
  ["/about", <AboutPage />],
  ["/login", <LoginPage />],
  ["/profile", <ProfilePage />],
  ["/auth/callback", <MagicLinkCallback />],
  ["/admin", <AdminPage />],
  ["/admin/metrics", <MetricsPage />],
  ["/messages", <MessagesPage />],
  ["/favorites", <FavoritesPage />],
  ["/my-events", <MyEventsPage />],
  ["/notifications", <NotificationsPage />],
  ["/organizer/events/:id/attendees", <OrganizerEventAttendeesPage />],
  ["/organizer/payments", <OrganizerPaymentsPage />],
  ["/terms", <PlaceholderPage title={termsContent.title} lastUpdated={termsContent.lastUpdated} sections={termsContent.sections} testId="terms-page" />],
  ["/privacy", <PlaceholderPage title={privacyContent.title} lastUpdated={privacyContent.lastUpdated} sections={privacyContent.sections} testId="privacy-page" />],
];

function App() {
  return (
    <div className="App min-h-screen eunoia-bg">
      <BrowserRouter basename={basename}>
        <AuthProvider>
          <LanguageProvider>
          <Navbar />
          <ErrorBoundary>
            <Routes>
              {routes.flatMap(([path, element]) => [
                <Route key={path} path={path} element={element} />,
                <Route key={`en${path}`} path={withLang(path, "en")} element={element} />,
              ])}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </ErrorBoundary>
          <Toaster />
          <InstallBanner />
          </LanguageProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
